export const ROLES = {
    OWNER: { id: '99', name: 'Owner' },
    ADMINISTRATOR: { id: '0', name: 'Administrator' },
    OFFICE: { id: '1', name: 'Office' },
    TECHNICIAN: { id: '2', name: 'Maintenance Tech' },
    DRIVER: { id: '3', name: 'Driver' },
};
export const ADDRESSES = {
    BILLING: { id: '1', name: 'Billing', source: ['customers', 'vendors'] },
    SERVICE: { id: '2', name: 'Service', source: ['customers'] },
    DELIVERY: { id: '3', name: 'Delivery', source: ['customers', 'vendors'] },
    PHYSICAL: { id: '4', name: 'Physical', source: ['customers', 'employees'] },
    MAILING: { id: '5', name: 'Mailing', source: ['customers', 'employees'] },
};
export const CONTACTS = {
    BILLING: { id: '1', name: 'Billing' },
    CONTACT: { id: '2', name: 'Contact' },
    MANAGER: { id: '3', name: 'Manager' },
    OWNER: { id: '4', name: 'Owner' },
};
export const PROFILES = {
    vendor: {
        singular: 'Vendor',
        plural: 'Vendors',
        index: 'vendor',
    },
};
export const QUOTE = {
    DRAFT: '1',
    PENDING: '2',
    REJECTED: '3',
    ACCEPTED: '4',
    CONVERTED: '5',
    CLOSED: '6',
};
export const REQUESTS = {
    UNASSIGNED: { id: '0', name: 'Unassigned', color: '#b3b3b3', description: 'One or more Work Order associated with this Service Request has not yet been assigned to a technician. This can be done by editing the Work Order, or dragging it to Technician\'s Schedule from the Schedule view.' },
    ASSIGNED: { id: '1', name: 'Assigned', color: '#16a5a5', description: 'All the Work Orders associated with this Service Request have been assigned to a technician.' },
    INCOMPLETE: { id: '2', name: 'Incomplete', color: '#e8e475', description: 'One or more Work Order associated with this Service Request has been marked as "Incomplete" for a specified reason, usually requiring followup by the Office or another Technician.' },
    COMPLETE: { id: '3', name: 'Complete', color: '#a4dd00', description: 'All the Work Orders for this Service Request have been marked as "Complete" by the Technician.' },
    CLOSED: { id: '4', name: 'Closed', color: '#333333' },
};
export const SCHEDULE_EVENT_TYPE = {
    RESERVED_TIMELINE: { id: '0', name: 'Reserved Timeline' },
    WORKORDER: { id: '1', name: 'Work Order' },
    REQUESTED_TIME_OFF: { id: '2', name: 'Requested Time Off' },
    APPROVED_TIME_OFF: { id: '3', name: 'Approved Time Off' },
    INTERNAL_WORKORDER: { id: '4', name: 'Internal Work Order' },
};
export const STATUS_TABLES = {
    REQUESTS: { name: 'Service Requests', singular: 'Service Request' },
    WORKORDERS: { name: 'Work Orders', singular: 'Work Order' },
};
export const UNITS = {
    EACH: { id: '0', name: 'each' },
    PAIR: { id: '1', name: 'pair' },
    POUND: { id: '2', name: 'lb' },
    OUNCE: { id: '3', name: 'oz' },
    GALLON: { id: '4', name: 'gallon' },
    CASE: { id: '5', name: 'case' },
    FOOT: { id: '6', name: 'foot' },
};
export const URGENCY = {
    LOW: { id: '0', name: 'Low', color: '#cccccc' },
    MEDIUM: { id: '1', name: 'Medium', color: 'green' },
    HIGH: { id: '2', name: 'High', color: '#ffbf00' },
    URGENT: { id: '3', name: 'Urgent', color: '#ff4000' },
};
export const WORKORDERS = {
    UNASSIGNED: { id: '0', name: 'Unassigned', color: '#b3b3b3', description: 'An "Unassigned" Work Order has been created but not assigned to a technician.  This can be done by editing the Work Order, or dragging it to Technician\'s Schedule from the Schedule view.', change: 'Changing the status to "Unassigned" will remove the current technician from the Work Order and allow another Technician to be assigned.', caution: true, possible: true },
    ASSIGNED: { id: '1', name: 'Assigned', color: '#16a5a5', description: '"Assigned" means that the Work Order has been assigned to a technician.', change: 'You cannot change the status to "Assigned" from here.  Please edit the Work Order and assign a Technician.', caution: false, possible: false },
    ENROUTE: { id: '2', name: 'Enroute', color: '#679cca', description: 'A Work Order marked as "Enroute" indicates that the Technician assigned to this Work Order is currently "Enroute" to the Service Request location.', change: 'You may set the status of this Work Order to indicate the Technician is "Enroute".  Automatic time tracking is only available on the App.', caution: false, possible: true },
    ONSITE: { id: '3', name: 'Onsite', color: '#937eca', description: 'A Work Order marked as "Onsite" indicates that the Technician assigned to this Work Order is currently "Onsite" at the Service Request location.', change: 'You may set the status of this Work Order to indicate the Technician is "Onsite".  Automatic time tracking is only available on the App.', caution: false, possible: true },
    INCOMPLETE: { id: '4', name: 'Incomplete', color: '#e8e475', description: 'An "Incomplete" Work Order has been marked as "Incomplete" for a specified reason usually requiring followup by the Office or another Technician', updatable: true },
    COMPLETE: { id: '5', name: 'Complete', color: '#a4dd00', description: 'A Work Order marked as "Complete" has been updated with Line Items for materials and labor and is ready for Invoicing.', change: 'Changing the status to "Complete" enables the generation of an Invoice for this Work Order. Be sure all material and line items have been completed. ', caution: true, possible: true },
    CLOSED: { id: '6', name: 'Closed', color: '#333333', description: 'A "Closed" work Order has been Completed, Invoiced, and Paid, or Incomplete and Closed due to Customer Request.  There are no pending actions.', change: 'Changing the status to "Closed" will remove the Work Order from active status and expect no further action.', caution: true, possible: true },
};
export const DEFAULT_SCHEDULE = {
    1: {
        end: '17:00',
        isWorkDay: false,
        start: '07:00'
    },
    2: {
        end: '17:00',
        isWorkDay: true,
        start: '07:00'
    },
    3: {
        end: '17:00',
        isWorkDay: true,
        start: '07:00'
    },
    4: {
        end: '17:00',
        isWorkDay: true,
        start: '07:00'
    },
    5: {
        end: '17:00',
        isWorkDay: true,
        start: '07:00'
    },
    6: {
        end: '17:00',
        isWorkDay: true,
        start: '07:00'
    }
};
export const ADDITIONAL_FIELDS = {
    VEHICLES: {
        id: '0',
        name: 'Vehicles',
        fields: [
            { grid: 'col-6', label: 'Year', field: 'year', type: 'text' },
            { grid: 'col-6', label: 'Make', field: 'make', type: 'text' },
            { grid: 'col-6', label: 'Model', field: 'model', type: 'text' },
            { grid: 'col-6', label: 'VIN', field: 'vin', type: 'text' },
            { grid: 'col-6', label: 'Plate #', field: 'plate', type: 'text' },
        ],
        columns: [
            { name: "Year", field: "year" },
            { name: "Make", field: "make" },
            { name: "Model", field: "model" },
        ],
        search: [
            { name: "VIN", field: "vin", width: "0" },
            { name: "Plate #", field: "plate", width: "0" },
        ]
    },
    PROPERTIES: {
        id: '1',
        name: 'Properties',
        fields: [
            { grid: 'col-6', label: 'Address', field: 'address', type: 'text' },
            { grid: 'col-6', label: 'City', field: 'city', type: 'text' },
            { grid: 'col-6', label: 'State', field: 'state', type: 'text' },
            { grid: 'col-6', label: 'ZIP', field: 'zip', type: 'text' },
        ],
        columns: [
            { name: "Address", field: "address" },
        ]
    },
};
export const ACTIVITY_LOG = {
    SERVICE_REQUEST_CREATED: { id: '100', name: 'Service Request Created' },
    SERVICE_REQUEST_MODIFIED: { id: '101', name: 'Service Request Modified' },
    SERVICE_REQUEST_DELETED: { id: '102', name: 'Service Request Deleted' },
    SERVICE_REQUEST_ARCHIVED: { id: '103', name: 'Service Request Archived' },
    SERVICE_REQUEST_RESTORED: { id: '104', name: 'Service Request Restored' },
    SERVICE_REQUEST_VIEWED: { id: '105', name: 'Service Request Viewed' },

    WORK_ORDER_CREATED: { id: '200', name: 'Work Order Created' },
    WORK_ORDER_MODIFIED: { id: '201', name: 'Work Order Modified' },
    WORK_ORDER_DELETED: { id: '202', name: 'Work Order Deleted' },
    WORK_ORDER_ARCHIVED: { id: '203', name: 'Work Order Archived' },
    WORK_ORDER_RESTORED: { id: '204', name: 'Work Order Restored' },
    WORK_ORDER_SPLIT: { id: '205', name: 'Work Order Split' },

    USER_CREATED: { id: '300', name: 'User Created' },
    USER_MODIFIED: { id: '301', name: 'User Modified' },
    USER_DELETED: { id: '302', name: 'User Deleted' },
    USER_ARCHIVED: { id: '303', name: 'User Archived' },
    USER_RESTORED: { id: '304', name: 'User Restored' },

    SERVICE_ITEM_CREATED: { id: '400', name: 'Service Item Created' },
    SERVICE_ITEM_MODIFIED: { id: '401', name: 'Service Item Modified' },
    SERVICE_ITEM_DELETED: { id: '402', name: 'Service Item Deleted' },
    SERVICE_ITEM_ARCHIVED: { id: '403', name: 'Service Item Archived' },
    SERVICE_ITEM_RESTORED: { id: '404', name: 'Service Item Restored' },
    SERVICE_ITEM_CATEGORY_CREATED: { id: '405', name: 'Service Item Category Created' },

    QUOTE_CREATED: { id: '500', name: 'Quote Created' },
    QUOTE_MODIFIED: { id: '501', name: 'Quote Modified' },
    QUOTE_DELETED: { id: '502', name: 'Quote Deleted' },
    QUOTE_ARCHIVED: { id: '503', name: 'Quote Archived' },
    QUOTE_RESTORED: { id: '504', name: 'Quote Restored' },

    PROFILE_CREATED: { id: '600', name: 'Profile Created' },
    PROFILE_MODIFIED: { id: '601', name: 'Profile Modified' },
    PROFILE_DELETED: { id: '602', name: 'Profile Deleted' },
    PROFILE_ARCHIVED: { id: '603', name: 'Profile Archived' },
    PROFILE_RESTORED: { id: '604', name: 'Profile Restored' },
    CUSTOMER_VIEWED: { id: '605', name: 'Customer Viewed' },
    EMPLOYEE_INVITATION_SENT: { id: '606', name: 'Employee Invitation Sent' },

    QUOTE_GENERATED: { id: '700', name: 'Quote Generated' },
    QUOTE_PRINTED: { id: '701', name: 'Quote Printed' },
    QUOTE_EMAILED: { id: '702', name: 'Quote Emailed' },

    MESSAGE_SENT: { id: '800', name: 'Message Sent' },

    DEPARTMENT_CREATED: { id: '900', name: 'Department Created' },
    DEPARTMENT_MODIFIED: { id: '901', name: 'Department Modified' },
    DEPARTMENT_DELETED: { id: '902', name: 'Department Deleted' },
    DEPARTMENT_ARCHIVED: { id: '903', name: 'Department Archived' },
    JOB_CATEGORY_CREATED: { id: '904', name: 'Job Category Created' },
    JOB_CATEGORY_MODIFIED: { id: '905', name: 'Job Category Modified' },
    JOB_CATEGORY_DELETED: { id: '906', name: 'Job Category Deleted' },
    JOB_CATEGORY_ARCHIVED: { id: '907', name: 'Job Category Archived' },

    CALL_LOG_STARTED: { id: '1000', name: 'Call Log Started' },
    CALL_LOG_SAVED_INCOMPLETE: { id: '1001', name: 'Incomplete Call Log Saved' },
    CALL_LOG_TO_SERVICE_REQUEST: { id: '1002', name: 'Call Log Saved to Service Request' },
    CALL_LOG_TRANSFERRED: { id: '1003', name: 'Call Log Transferred' },

    EVENT_CREATED: { id: '1100', name: 'Added Event to Schedule' },
    EVENT_REASSIGNED: { id: '1101', name: 'Reassigned Event on Schedule' },
    EVENT_TIME_MOVED: { id: '1102', name: 'Moved Event Time on Schedule' },
    EVENT_DRAG_CHANGED: { id: '1103', name: 'Drag Changed Event Duration on Schedule' },
};
